module.exports = __webpack_public_path__ + "img/documents.6bb57657.jpg";